export default __webpack_public_path__ + "maps-examples-dds-circle-layer-thumbnail-960-89e0b4a4d92f529bfdbe2d21e4445a6b.png";